export function formatNullableNumber (val: number | null): string {
  return val == null || Number.isNaN(val) ? '' : val.toString();
}
